import { useTranslation } from "react-i18next";
// 引入对应图片（需放入 src/assets/images/）
import eduImg from "../assets/images/philosophy-edu.webp";
import communityImg from "../assets/images/philosophy-community.webp";
import industryImg from "../assets/images/philosophy-industry.webp";
import "./InvestmentPhilosophySection.scss";
import MagicBento from "./MagicBento";
import ScrollFloat from "../repo/ScrollFloat";
import HeaderBg from "../assets/images/B-logo@2x.webp";
const InvestmentPhilosophySection = () => {
  const { t } = useTranslation();
  const bannerStyle = {
    backgroundImage: `url(${HeaderBg})`
  };
  return (
    <section className='philosophy-section' style={bannerStyle}>
      {/* 1. 标题区 */}
      <div className='philosophy-header'>
        {/* <h2 className='philosophy-title'>{t("investment.title")}</h2> */}
        <ScrollFloat
          animationDuration={1}
          ease='back.inOut(2)'
          scrollStart='center bottom+=50%'
          scrollEnd='bottom bottom-=40%'
          textClassName='float-text'
          stagger={0.03}
        >
          {t("investment.title")}
        </ScrollFloat>
      </div>

      {/* 2. 投资理念卡片区 */}
      <div className='philosophy-cards g-inner'>
        <div className='container'>
          <div className='card-wrap'>
            <MagicBento
              textAutoHide={true}
              enableStars={true}
              enableSpotlight={true}
              enableBorderGlow={true}
              enableTilt={true}
              enableMagnetism={true}
              clickEffect={true}
              spotlightRadius={300}
              particleCount={12}
              glowColor='247, 224, 187'
            >
              {/* 产融结合卡片 */}
              <div className='philosophy-card'>
                <h3 className='card-title'>{t("investment.card1Title")}</h3>
                <p className='card-desc'>{t("investment.card1Desc")}</p>
              </div>
              {/* 全球收并购视野卡片 */}
              <div className='philosophy-card'>
                <h3 className='card-title'>{t("investment.card2Title")}</h3>
                <p className='card-desc'>{t("investment.card2Desc")}</p>
              </div>
              {/* 全周期赋能卡片 */}
              <div className='philosophy-card'>
                <h3 className='card-title'>{t("investment.card3Title")}</h3>
                <p className='card-desc'>{t("investment.card3Desc")}</p>
              </div>
            </MagicBento>
          </div>
        </div>
      </div>

      {/* 3. 社会责任板块 */}
      <div className='philosophy-csr'>
        <div className='container g-inner'>
          <div className='csr-top ' id={t("navbar.csr")}>
            <h3 className='csr-title sub-font'>{t("investment.csrTitle")}</h3>
            <p className='csr-desc g-pre-line'>{t("investment.csrDesc")}</p>
          </div>
          <div className='csr-cards '>
            {/* 教育公益 */}
            <div className='csr-card'>
              <img
                src={eduImg}
                alt={t("investment.eduAlt")}
                className='csr-img'
              />
              <h4 className='csr-card-title g-pre-line'>
                {t("investment.eduTitle")}
              </h4>
              <p className='csr-card-desc g-pre-line sub-font'>
                {t("investment.eduDesc")}
              </p>
            </div>
            {/* 社区公益 */}
            <div className='csr-card'>
              <img
                src={communityImg}
                alt={t("investment.communityAlt")}
                className='csr-img'
              />
              <h4 className='csr-card-title'>
                {t("investment.communityTitle")}
              </h4>
              <p className='csr-card-desc sub-font'>
                {t("investment.communityDesc")}
              </p>
            </div>
            {/* 产业公益 */}
            <div className='csr-card'>
              <img
                src={industryImg}
                alt={t("investment.industryAlt")}
                className='csr-img'
              />
              <h4 className='csr-card-title'>
                {t("investment.industryTitle")}
              </h4>
              <p className='csr-card-desc sub-font'>
                {t("investment.industryDesc")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InvestmentPhilosophySection;
